<script lang="ts">
  import type { CrawlerSource } from '../../modules/crawler/crawler-source.interface';
  import { createEventDispatcher } from 'svelte';
  import { TextField, Button, SlideGroup, SlideItem, Icon } from 'svelte-materialify';
  import { SourceCrawlerType } from '../../modules/source/source.constants';
  import { CrawlerService, SourceService } from '../../modules';
  import { wrapProgress } from '../../store';
  import SourceCard from './SourceCard.svelte';

  export let type: SourceCrawlerType;

  const dispatch = createEventDispatcher();
  let sourceQuery = '';
  let crawlerSourceList: CrawlerSource[] = [];
  let selectedSlideIdx: [] | number;
  let message: string;

  $: sourceIdx = !Number.isInteger(selectedSlideIdx) ? -1 : (selectedSlideIdx as number);
  $: onSourceChange(sourceIdx);

  async function search() {
    selectedSlideIdx = [];
    message = '';
    const isInstagram = type === SourceCrawlerType.INSTAGRAM;
    crawlerSourceList = isInstagram
      ? [SourceService.createInstagramSource(sourceQuery)]
      : await CrawlerService.searchSources(type, sourceQuery);

    if (isInstagram && crawlerSourceList.length === 1) {
      onSourceChange(0);
    }

    if (!crawlerSourceList.length) {
      message = 'No sources found!';
    }
  }

  function getItemClass(sourceIdx: number, idx: number) {
    if (sourceIdx < 0) return '';

    return sourceIdx !== idx ? 'not-selected' : 'selected';
  }

  function onSourceChange(sourceIdx: number) {
    if (sourceIdx < 0) return;

    const crawlerSource = crawlerSourceList[sourceIdx] || null;
    dispatch('select', crawlerSource);
  }
</script>

<div class="d-flex mb-4">
  <TextField bind:value={sourceQuery} outlined>Source name</TextField>
  <div class="ml-4">
    <Button class="green white-text" on:click={wrapProgress(search)} size="x-large"
      >Search source
    </Button>
  </div>
</div>
{#if crawlerSourceList.length}
  <SlideGroup class="mb-6" activeClass="white-text" bind:value={selectedSlideIdx}>
    <span slot="previous">
      <Icon class="mdi mdi-chevron-left" />
    </span>
    {#each crawlerSourceList as crawlerSource, idx}
      <SlideItem>
        <SourceCard {crawlerSource} className={getItemClass(sourceIdx, idx)} />
      </SlideItem>
    {/each}
    <span slot="next">
      <Icon class="mdi mdi-chevron-right" />
    </span>
  </SlideGroup>
{/if}
{#if message}
  <p>{message}</p>
{/if}

<style lang="scss">
  :global(.s-item-group) {
    background-color: #f0f0f0;
    border-radius: 6px;
    overflow: hidden;
  }
</style>
